export default "__VITE_ASSET__D4DWq1Lq__"